import { FC } from 'react';
import { Button, ButtonProps } from 'antd';

const TextButton: FC<ButtonProps> = ({ title, ...props }) => {
  return (
    <Button type='text' {...props}>
      {title}
    </Button>
  );
};

export default TextButton;
